import * as Sentry from '@sentry/nextjs'

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN

Sentry.init({
  enabled: process.env.NEXT_PUBLIC_SENTRY_ENABLED === 'true',
  dsn: SENTRY_DSN,
  tracesSampleRate: parseFloat(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || process.env.NODE_ENV,

  // Enhanced error capturing for React components
  beforeSend (event) {
    // Only send errors in production or when explicitly enabled
    if (process.env.NODE_ENV === 'development' && process.env.NEXT_PUBLIC_SENTRY_ENABLED !== 'true') {
      console.log('❌ Sentry: Blocking event in development mode (NEXT_PUBLIC_SENTRY_ENABLED not set to "true")')
      return null
    }

    return event
  },

  // Configure which integrations to use
  integrations: [
    // Capture unhandled promise rejections
    new Sentry.Integrations.GlobalHandlers({
      onunhandledrejection: true,
    }),
    // Capture browser history for better debugging
    new Sentry.Integrations.Breadcrumbs({
      console: true,
      dom: true,
      fetch: true,
      history: true,
      xhr: true,
    }),
  ],

  // Additional options for better error reporting
  attachStacktrace: true,
  sendDefaultPii: false, // Don't send personally identifiable information

  // Configure what types of errors to capture
  ignoreErrors: [
    // Browser extensions
    'top.GLOBALS',
    // Random plugins/extensions
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    'Can\'t find variable: ZiteReader',
    'jigsaw is not defined',
    'ComboSearch is not defined',
    // Facebook flakiness
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'Script error.',
    // Network errors
    'NetworkError',
    'Failed to fetch',
    'Load failed',
    // Non-Error promise rejections
    'Non-Error promise rejection captured',
    // Application-specific errors that should not be reported
    'NotFoundError',
    'ForbiddenError',
    'UnauthenticatedError',
  ],
})
